export default "__VITE_ASSET__DCjPgw7$__"